import React from 'react'
import useRouter from './use-router'

export default function useOnNavigate (callback, dependencies = []) {
  const router = useRouter()

  const handleOnNavigate = (routeName, parameters = {}) => {
    if (typeof callback === 'function') {
      callback(routeName, parameters)
    }
  }

  React.useEffect(() => {
    router.onNavigate(handleOnNavigate)

    return () => {
      router.removeOnNavigateListener(handleOnNavigate)
    }
  }, dependencies)
}
